import React from "react";
import { Col, Row } from "react-bootstrap";

const categorias = {
  veiculo: ["Veículo", "dadosVeiculo"],
  arma_fogo: ["Arma de fogo", "dadosArma"],
  arma_branca: ["Arma branca", "dadosArmaBranca"],
  droga: ["Droga", "dadosDroga"],
  outro_objeto: ["Outros objetos/bens", "dadosObjeto"],
};

const rotulos = {
  pais: "País",
  placa: "Placa",
  uf: "UF",
  renavam: "RENAVAM",
  chassi: "Chassi",
  municipioRegistro: "Município de registro",
  situacaoRegistro: "Situação de registro",
  especie: "Espécie",
  tipoVeiculo: "Tipo de veículo",
  marca: "Marca",
  modelo: "Modelo",
  categoria: "Categoria",
  corPredominante: "Cor predominante",
  anoFabricacao: "Ano de fabricação",
  anoModelo: "Ano-modelo",
  situacaoAdministrativa: "Situação administrativa/criminal",
  proprietario: "Proprietário",
  acabamento: "Acabamento",
  quantidadeCanos: "Quantidade de canos",
  fabricacao: "Fabricação",
  tipoUso: "Tipo de uso",
  calibreReal: "Calibre real",
  numeroRegistro: "Número SIGMA/SINARM",
  numeroSerie: "Número de série",
  situacaoNumeroSerie: "Situação do número de série",
  tipoDroga: "Tipo de droga",
  tipoArmaBranca: "Tipo de arma branca",
  substancia: "Substância",
  quantidade: "Quantidade",
  unidade: "Unidade",
  informacoesCarga: "Faz parte de um carregamento",
  observacoes: "Observações",
  tipoObjeto: "Tipo de objeto/bem",
  descricao: "Descrição do objeto",
  materialFabricacao: "Material de fabricação",
  comprimentoAproximadoCm: "Comprimento aproximado",
  caracteristicasDistintivas: "Características distintivas",
  estadoConservacao: "Estado de conservação",
  participacoes: "Participação na ocorrência",
};

const nomesParticipacao = {
  apreendido: "Apreendido",
  encontrado: "Encontrado",
  subtraido: "Subtraído",
  apreendido_infracao_transito: "Apreendido por infração de trânsito",
};

const formatarValor = (chave, valor) => {
  if (Array.isArray(valor)) {
    return chave === "participacoes"
      ? valor.map((item) => nomesParticipacao[item] || item).join(", ")
      : valor.join("; ");
  }
  if (typeof valor === "boolean") return valor ? "Sim" : "Não";
  if (valor === "sem_registro") return "Sem registro";
  if (valor === "registrado") return "Registrado";
  if (valor === "nao_identificado") return "Não foi possível identificar";
  if (valor === "suprimido") return "Suprimido";
  if (valor === "nao_informado") return "Não informado";
  if (valor === "permitido") return "Permitido";
  if (valor === "restrito") return "Restrito";
  if (chave === "comprimentoAproximadoCm") return `${valor} cm`;
  if (chave === "estadoConservacao") {
    return { integro: "Íntegro", danificado: "Danificado", outro: "Outro" }[valor] || valor;
  }
  return valor;
};

const MaterialDetalhe = ({ material }) => {
  const categoria = categorias[material.tipoItem];
  if (!categoria) {
    return (
      <Row>
        <Col><b>Descrição: </b>{material.descricao}</Col>
        <Col><b>Quantidade: </b>{material.quantidade}</Col>
      </Row>
    );
  }

  const [nomeCategoria, chaveDados] = categoria;
  const dados = material[chaveDados] || {};
  const campos = Object.entries(dados).filter(([, valor]) =>
    valor !== "" && valor !== null && valor !== undefined &&
    (!Array.isArray(valor) || valor.length > 0)
  );

  return (
    <section className="mb-2">
      <Row><Col><b>Categoria: </b>{nomeCategoria}</Col></Row>
      {material.tipoItem === 'arma_fogo' && material.quantidade !== undefined && material.quantidade !== '' && <Row><Col><b>Quantidade de armas: </b>{material.quantidade}</Col></Row>}
      {campos.map(([chave, valor]) => (
        <Row key={chave}>
          <Col>
            <b>{rotulos[chave] || chave}: </b>
            {formatarValor(chave, valor)}
          </Col>
        </Row>
      ))}
    </section>
  );
};

export default MaterialDetalhe;
